import { EventVm, UpdateEventCommand } from '../../../../utils/api';
import Challenge from './Challenge';

interface OwnProps {
    isHomeTeam: boolean;
    event: UpdateEventCommand;
    updateEvent: (event: UpdateEventCommand) => void;
    clearEvent: () => void;
    deleteEvent: (event: EventVm) => void;
}

export type Props = OwnProps;

export default Challenge;
